<template>
  <div
    class="question-list-component"
  >
    <router-link
      v-for="state in sortedStates"
      :key="`state-${state.flashcardId}`"
      :to="questionRoute(state)"
      class="question-container"
    >
      <icon
        class="icon"
        :class="{correct: state.correct}"
        :name="state.correct ? 'check' : 'cross'"
        variant="white"
      />
      <div
        class="question"
        v-html="html(state)"
      />
      <icon
        name="arrow"
        class="arrow"
      />
    </router-link>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

import GlobalMixin from '@/mixins/global';

import { stripHtml } from '@/utils';

export default {
  components: { Icon },
  mixins: [GlobalMixin],
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    states: {
      type: Array,
      default: () => [],
    },
    sortByState: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sortedStates() {
      if (this.sortByState) {
        let states = this.states.filter(s => this.question(s));
        return states.sort((a, b) => b.mobileCreatedAt - a.mobileCreatedAt);
      }

      return this.states;
    },
  },
  methods: {
    html(state) {
      const question = this.question(state);
      return question && stripHtml(question.question);
    },
    question(state) {
      return this.questions.find(q => q.id === state.flashcardId);
    },
    questionRoute(state) {
      let question = this.question(state);
      if (this.currentResource.destination === 'user_certification') {
        return {name: 'userCertifications#progress#flashcard', params: {flashcardId: question.id}, query: this.currentQuery};
      } else if (this.currentResource.destination === 'test_simulations') {
        return {name: 'testSimulations#results#question', params: {flashcardId: question.id}, query: this.currentQuery};
      } else if (state.assetAssociationId) {
        return {name: 'groupings#show', params: { ...this.$route.params, assetAssociationId: state.assetAssociationId }, query: { review: true }};
      } else {
        // assuming we are in quiz results
        return {name: 'quizzes#results#question', params: {flashcardId: question.id}, query: this.currentQuery};
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.question-list-component {
  .question-container {
    display: flex;
    align-items: center;
    padding: rem-calc(16) rem-calc(8);
    border-radius: rem-calc(8);

    &:hover {
      background-color: #fafafa;
    }

    .icon {
      background-color: #dc3416;
      border-radius: 100%;
      height: rem-calc(20);
      margin-right: rem-calc(16);
      padding: rem-calc(4);
      width: rem-calc(20);

      &.correct {
        background-color: #00bc5c;
      }

    }

    .question {
      color: black;
      flex: 1;
      font-size: rem-calc(14);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .arrow {
      margin-left: rem-calc(16);
      height: rem-calc(12);
      width: rem-calc(12);
    }
  }
}
</style>
